// As we're using immer

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StatusUpdate } from 'api/status-updates';
import { RootState } from 'data';
import { StatusUpdatesState, HighlightData } from './constants';

const INITIAL_STATE: StatusUpdatesState = {
  active: null,
  activeHighlightsData: {},
  items: [],
  loading: true,
};
const StatusUpdatesSlice = createSlice({
  name: 'statusUpdates',
  initialState: INITIAL_STATE,

  reducers: (create) => ({
    setStatusUpdates: create.reducer(
      (state, action: PayloadAction<StatusUpdate[]>) => {
        state.items = action.payload;
        state.loading = false;
        if (!state.active) {
          state.active = action.payload[0] || null;
        }
      },
    ),

    appendStatusUpdate: create.reducer(
      (state, action: PayloadAction<StatusUpdate>) => {
        state.items.push(action.payload);
      },
    ),

    updateStatusUpdate: create.reducer(
      (state, action: PayloadAction<StatusUpdate>) => {
        state.items = state.items.reduce((acc, item, index) => {
          if (item.statusUpdateId === action.payload.statusUpdateId) {
            acc.push({
              ...state.items[index],
              ...action.payload,
            });
          } else {
            acc.push(state.items[index]);
          }

          return acc;
        }, [] as StatusUpdate[]);
        state.loading = false;
      },
    ),

    setStatusUpdatesLoading: create.reducer(
      (state, action: PayloadAction<boolean>) => {
        state.loading = action.payload;
      },
    ),

    setActiveStatusUpdate: create.reducer(
      (state, action: PayloadAction<StatusUpdate>) => {
        state.active = {
          ...action.payload,
          collaborators: action.payload.collaborators || [],
        };
      },
    ),

    setActiveStatusUpdateTitle: create.reducer(
      (state, action: PayloadAction<string>) => {
        if (state.active === null) {
          return;
        }
        state.active.statusUpdateTitle = action.payload;
      },
    ),

    setActiveStatusUpdateHighlightsData: create.reducer(
      (state, action: PayloadAction<HighlightData>) => {
        state.activeHighlightsData = {
          ...state.activeHighlightsData,
          ...action.payload,
        };
      },
    ),

    removeStatusUpdate: create.reducer(
      (state, action: PayloadAction<StatusUpdate>) => {
        state.items = state.items.filter(
          (item) => item.statusUpdateId !== action.payload.statusUpdateId,
        );
        const firstStatusUpdate = state.items[0];

        state.active = firstStatusUpdate;
      },
    ),
  }),
});

export const selectStatusLoading = (state: RootState): boolean =>
  state.statusUpdates.loading;
export const selectStatusUpdates = (state: RootState): StatusUpdate[] =>
  state.statusUpdates.items;
export const selectActiveStatusUpdate = (
  state: RootState,
): StatusUpdate | null => {
  return state.statusUpdates.active;
};
export const selectActiveStatusUpdateHighlightTasks = (
  state: RootState,
): HighlightData => {
  return state.statusUpdates.activeHighlightsData;
};

// TODO: Check whether I need this. let saga take care of this?
export const {
  setStatusUpdates,
  appendStatusUpdate,
  updateStatusUpdate,
  setStatusUpdatesLoading,
  setActiveStatusUpdate,
  setActiveStatusUpdateTitle,
  setActiveStatusUpdateHighlightsData,
  removeStatusUpdate,
} = StatusUpdatesSlice.actions;
export const statusUpdatesReducer = StatusUpdatesSlice.reducer;
